import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import GoogleMapReact from 'google-map-react'
import Loading from 'custom/assets/loaders/Loading'
import NeoInput from '../../components/NeoInput/NeoInput'
import { LANDING_KEYS } from '../../utils/translation-constants'
import BranchService from '../../services/branches.service'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import { useHistory } from 'react-router-dom'
import Config from 'custom/config/environment'

export default function Branch() {
  const { t } = useTranslation()
  const [locations, setLocations] = useState({})
  const [zoom, setZoom] = useState(3)
  const [isLoading, setLoading] = useState(false)
  const [mapCenter, setMapCenter] = useState(Config.COORDINATES)
  const [tabList, setTabList] = useState([])
  const [selectedTab, setSelectedTab] = useState('')
  const [noRecords, setNoRecords] = useState(false)

  const Marker = () => (
    <div>
      <img
        src='https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi.png'
        alt='boohoo'
        className='img-responsive'
      />
    </div>
  )

  const locationNameCallback = useCallback(
    (e) => {
      const selected = locations[selectedTab].filter(
        (ele) => ele.locationName === e.target.value,
      )[0]
      setMapCenter({
        lat: parseFloat(selected?.latitude),
        lng: parseFloat(selected?.longitude),
      })
      setZoom(15)
    },
    [locations, selectedTab],
  )

  useEffect(() => {
    setMapCenter(Config.COORDINATES)
    setZoom(5)
  }, [selectedTab])

  const getLocations = useCallback(async () => {
    try {
      setLoading(true)
      const response = await BranchService.getLocations({ locationType: 'ALL' })
      if (response.status === 200) {
        setLoading(false)
        setNoRecords(response.data.length > 0 ? false : true)
        if (response.data) {
          const locationDetails = response.data.reduce(function (location, obj) {
            ;(location[obj['locationType']] = location[obj['locationType']] || []).push(obj)
            return location
          }, {})
          if (Object.keys(locationDetails).length > 0) {
            setSelectedTab(Object.keys(locationDetails)[0])
            setTabList(Object.keys(locationDetails))
            setLocations(locationDetails)
          }
        }
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getLocations()
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='BRANCH' showEmptySpace={true} keyPath={'BRANCH'}>
      <div className='new-design-form-style'>
        {isLoading && renderLoading()}

        {noRecords && (
          <span className='noRecords-text-style'>{t(LANDING_KEYS.LOCATION_NO_INFO)}</span>
        )}

        {tabList.length > 0 && (
          <div className='row tab-navbar'>
            {tabList.map((tab, index) => (
              <div
                key={index}
                className={tab === selectedTab ? `col-${12 / tabList.length} selected` : `col-${12 / tabList.length}`}>
                <span onClick={() => setSelectedTab(tab)}>{tab}</span>
              </div>
            ))}
          </div>
        )}

        {Object.keys(locations).length > 0 && (
          <>
            <div className='form-group text-dark'>
              <NeoInput
                tabIndex='1'
                mode='native-select'
                onChange={locationNameCallback}
                text={t(LANDING_KEYS.CHOOSE)}
                list={locations[selectedTab] || []}
                keyValue={'locationName'}
              />
            </div>

            <div className='my-5' style={{ height: '50vh', width: '100%' }}>
              <GoogleMapReact
                bootstrapURLKeys={{ key: Config.GOOGLE_MAPS_API_KEY }}
                center={mapCenter}
                defaultZoom={13}
                zoom={zoom}>
                {locations[selectedTab].map((value, i) => (
                  <Marker key={i} lat={value.latitude} lng={value.longitude} />
                ))}
              </GoogleMapReact>
            </div>
          </>
        )}
      </div>
    </LayoutWithOutAccountCard>
  )
}
